// Scripts
import '~scripts/main';

// Packages
import Vue from 'vue';

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { stripTrailingSlash } from '~scripts/core/helpers';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import '~scripts/blocks/events/event-video';

// Components
import '~scripts/components/modals';
import { backgroundAnimation } from '~scripts/components/ai-background/background-animation';
import {
  retrieveBackgroundAnimation,
  releaseBackgroundAnimation,
} from '~scripts/components/ai-background/backgrounds-pool';
import ParticipateForm from '~scripts/components/vue/forms/ParticipateForm.vue';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// BANNER
//
const pathname = stripTrailingSlash(location.pathname);

// AI: /events/ai-for-hr
if (pathname === '/events/ai-for-hr') {
  const aiBackgroundEl = document.getElementById('ai-background');
  let backgroundAnimationData = backgroundAnimation;

  const toggleAiBackground = () => {
    if (mediaSm.matches) {
      if (backgroundAnimationData) {
        releaseBackgroundAnimation(backgroundAnimationData);
      }
    } else {
      if (aiBackgroundEl) {
        backgroundAnimationData = retrieveBackgroundAnimation({
          refraction: 0.15,
          offset: 0.18,
          speed: 0.03,
          curvature: 1.0,
          width: 55,
          fps: 30,
        });
        backgroundAnimationData.attach(aiBackgroundEl);
      }
    }
  };

  toggleAiBackground();
  mediaSm.addEventListener('change', toggleAiBackground);
}

//
// FORM
//
const formWrappers = document.querySelectorAll('.js-form-wrapper');

formWrappers.forEach((formWrap) => {
  const formName = formWrap.dataset.form;
  const component = formName === 'SubscribeForm' ? SubscribeForm : ParticipateForm;

  new Vue({
    el: formWrap,
    components: {
      [formName]: component,
    },
  });
});
